import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import MyContext from "../context/MyContext";
import Loading from "../components/Loading";

const UserRoute = ({ path, component, redirectTo = "/login" }) => {
  const contex = useContext(MyContext);
  const { user, authIsDone } = contex;

  if (!authIsDone) return <Loading />;
  if (authIsDone) {
    // return user && user.emailIsVerified === true ? (
    return user ? (
      <Route path={path} component={component} />
    ) : (
      <Redirect to={redirectTo} />
    );
  }
};

export default UserRoute;
